/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import {
  Form,
  Button,
  Checkbox,
  Select,
  message,
  InputNumber,
  Tooltip,
} from 'antd';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Layout from '../../layouts/User';
import Loading from '../../components/Loading';

const { Option } = Select;

const breadcrumbs = [
  {
    text: 'หน้าแรก',
    path: '/',
  },
  {
    text: 'ตะกร้าสินค้า',
    path: '/cart',
  },
];

export type Props = {};

const Register: React.FC<Props> = (props) => {
  const user = useSelector((state: any) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [shopItems, setShopItems] = useState([]);
  const [delivery, setDelivery] = useState<string>(
    'ตัวเลือกการจัดส่ง'
  );
  const [isOutStock, setIsOutStock] = useState<boolean>(false);
  const [cart, setCart] = useState<any>({
    shops: [],
  });
  const [cartPrice, setCartPrice] = useState<any>({
    shops: [],
  });

  const [state, setState] = useState<any>({
    shops: [],
  });

  const getCarts = async (id: any) => {
    setLoading(true);
    let { data } = await axios.get(`/carts/${id}`);
    if (!data) {
      return;
    }
    setShopItems(data.shops);
    setCart(data);
    setLoading(false);
    setWholesale(data);
  };

  const setWholesale = async (data: any) => {
    const shopBuyer = await axios.get(
      `/shop-buyer/shop-buyer/${user?._id}`
    );
    data.shops = data.shops.map((x: any) => ({
      ...x,
      isChecked: false,
      shopBuyer: shopBuyer.data.find(
        (z: any) => z?.shop?._id === x?.shop?._id
      ),
      products: shopBuyer
        ? x.products.map((y: any) => ({
            ...y,
            isChecked: false,
            isOutOfStock:
              y?.amount > y?.product?.stock ? true : false,
            wholesalePrice:
              y?.product?.wholesale &&
              y?.product?.wholesale.find(
                (z: any) => z.min <= y.amount && z.max >= y.amount
              )
                ? y?.product?.wholesale.find(
                    (z: any) => z.min <= y.amount && z.max >= y.amount
                  )?.price
                : y?.product?.memberPrice,
          }))
        : x.products.map((y: any) => ({
            ...y,
            isChecked: false,
            isOutOfStock:
              y?.amount > y?.product?.stock ? true : false,
            wholesalePrice:
              y?.product?.wholesale &&
              y?.product?.wholesale.find(
                (z: any) => z.min <= y.amount && z.max >= y.amount
              )
                ? y?.product?.wholesale.find(
                    (z: any) => z.min <= y.amount && z.max >= y.amount
                  )?.price
                : y?.product?.price,
          })),
    }));

    data.shops = data.shops.map((x: any) => ({
      ...x,
      isChecked: false,
      isOutOfStock: x?.products?.some(
        (y: any) => y?.amount > y?.product?.stock
      ),
      products: shopBuyer
        ? x.products.map((y: any) => ({
            ...y,
            isChecked: false,
            isOutOfStock:
              y?.amount > y?.product?.stock ? true : false,
            wholesalePrice:
              y?.product?.wholesale &&
              y?.product?.wholesale.find(
                (z: any) => z.min <= y.amount && z.max >= y.amount
              )
                ? y?.product?.wholesale.find(
                    (z: any) => z.min <= y.amount && z.max >= y.amount
                  )?.price
                : y?.product?.memberPrice,
          }))
        : x.products.map((y: any) => ({
            ...y,
            isChecked: false,
            isOutOfStock:
              y?.amount > y?.product?.stock ? true : false,
            wholesalePrice:
              y?.product?.wholesale &&
              y?.product?.wholesale.find(
                (z: any) => z.min <= y.amount && z.max >= y.amount
              )
                ? y?.product?.wholesale.find(
                    (z: any) => z.min <= y.amount && z.max >= y.amount
                  )?.price
                : y?.product?.price,
          })),
    }));

    setCart({ ...data });
    if (data?.shops.length > 0) {
      onShopChangeV2(data?.shops[0]);
    }

    mapCartsV2(state, { ...data });
    mapPrice({ ...data });
    checkStockCart(data?.shops[0]);
  };

  const onShopChangeV2 = (shop: any) => {
    let shops = cart.shops;
    let dataShops: any = state.shops;

    let objShops = dataShops;
    if (!dataShops.length) {
      objShops = [dataShops];
    }

    // if (value) {
    // check all
    shops = shops.map((x: any) => ({
      ...x,
      products: x.products.map((y: any) => ({
        ...y,
        isChecked: x?._id === shop?._id ? true : y.isChecked,
      })),
    }));

    if (!dataShops.length) {
      objShops = [dataShops];
    }

    const objShop = objShops.find((x: any) => x?._id === shop?._id);

    if (!objShop) {
      const body = {
        ...shop.shop,
        _id: shop?._id,
        shop: shop?.shop?._id,
        isChecked: shop.isChecked,
        products: shop?.products?.map((y: any) => ({
          ...y,
          isChecked: true,
        })),
      };
      dataShops.push(body);
    } else {
      const body = {
        ...shop.shop,
        _id: shop?._id,
        shop: shop?.shop?._id,
        isChecked: shop.isChecked,
        products: shop?.products?.map((y: any) => ({
          ...y,
          isChecked: true,
        })),
      };
      let objShops = [];

      for (let i = 0; i < dataShops?.length; i++) {
        if (dataShops[i]?._id === shop?._id) {
          dataShops[i] = body;
          objShops.push(dataShops[i]);
        }
      }

      dataShops = objShops;
    }

    setState({ ...state, shops: dataShops });
    setCart({
      ...cart,
      shops,
    });
    mapShops({ ...state, shops: dataShops });
  };

  const checkStockCart = (data: any) => {
    const item = { ...data };
    const checkOutOfStock = item.products?.filter(
      (item: any) => item.isOutOfStock
    );
    checkOutOfStock?.length > 0
      ? setIsOutStock(true)
      : setIsOutStock(false);
  };

  const onClickToShop = async () => {
    navigate('/');
  };

  const onPaymentClick = async () => {
    if (state.shops.length > 0) {
      setLoading(true);

      let body = state?.shops?.map((x: any) => {
        const obj = {
          ...x,
          idcart: x?._id,
        };
        delete obj?._id;
        return obj;
      });

      for (const shop of body) {
        if (!shop.products.length) {
          const index = body.findIndex(
            (x: any) => x.idcart === shop?._id
          );
          body.splice(index, 1);
        }
      }

      let boxamount = 0;
      for (const amount of body) {
        boxamount = amount.totalAmount;
      }
      const datas = {
        user: user?._id,
        shops: body,
        delivery: state?.delivery,
        allPrice: cartPrice?.totalPrice,
        allAmount: boxamount,
      };

      const objShopInput = datas?.shops?.find(
        (x: any) => x.products.length !== 0
      );

      const shops = JSON.parse(JSON.stringify(cart.shops));

      // remove product in array
      for (const shop of cart.shops) {
        for (const product of shop.products) {
          if (product.isChecked) {
            const nShop = shops.find(
              (x: any) => x?._id === shop?._id
            );
            const index = nShop.products.findIndex(
              (x: any) => x?._id === product?._id
            );
            nShop.products.splice(index, 1);
          }
        }

        // remove shop from array
        const objShop = shops.find((x: any) => x?._id === shop?._id);
        if (!objShop.products.length) {
          const index = shops.findIndex(
            (x: any) => x?._id === objShop?._id
          );
          shops.splice(index, 1);
        }
      }
      const addCart = shops.map((x: any) => ({
        shop: x?.shop?._id,
        products: x.products.map((y: any) => ({
          amount: y.amount,
          product: y?.product?._id,
        })),
      }));

      const bodyCart = {
        userId: user?._id,
        shops: addCart,
      };

      //update cart
      await axios.patch(`/carts/new-cart/${cart._id}`, bodyCart);

      if (objShopInput) {
        const orderId = await axios.post(`/orders`, datas);
        if (orderId) {
          navigate(`/cart/order-summary?id=${orderId?.data?._id}`);
        }
      }
    } else {
      message.error('ยังไม่มีสินค้าในตะกร้า');
    }
  };

  const onAmountChange = (
    value: any,
    shop: any,
    product: any,
    index: number
  ) => {
    if (shop.products[index].product.stock < value) {
      message.warning('ปริมาณสินค้าใน stock ไม่เพียงพอ');
    }

    const getCart = cart;
    const objShop = getCart?.shops?.find(
      (x: any) => x?._id === shop?._id
    );

    if (objShop) {
      const objProduct = objShop.products.find(
        (y: any) => y?._id === product?._id
      );
      if (objProduct) {
        objProduct.amount = value;
      }
    }

    setWholesale(getCart);
    setState({
      shops: [],
    });
  };

  const onAmountChangeV2 = (
    value: any,
    shop: any,
    product: any,
    index: number
  ) => {
    if (shop.products[index].product.stock < value) {
      message.warning('ปริมาณสินค้าใน stock ไม่เพียงพอ');
    }
    const getCart = cart;
    const objProduct = getCart?.shops[0]?.products.find(
      (y: any) => y?._id === product?._id
    );
    if (objProduct) {
      objProduct.amount = value;
    }

    const shopSelected = getCart?.shops[0];
    shopSelected.totalPrice = getCart?.shops[0]?.products
      .map((y: any) => y.amount * y.wholesalePrice)
      .reduce((acc: number, curr: number) => {
        return acc + curr;
      }, 0);

    setWholesale(getCart);
    setState({
      shops: cart.shops,
    });
  };

  const mapShops = (item: any) => {
    let shops = item.shops.map((x: any) => ({
      ...x,
      totalAmount: x.products
        .map((z: any) => z.amount)
        .reduce((acc: number, curr: number) => {
          return acc + curr;
        }, 0),
      totalPrice: x.products
        .map((y: any) => y.amount * y.wholesalePrice)
        .reduce((acc: number, curr: number) => {
          return acc + curr;
        }, 0),
    }));

    setState({ shops });
  };

  const mapCarts = (item: any, carts: any) => {
    let shops = carts.shops.map((x: any) => ({
      ...x,
      totalPrice: x.products
        .map((y: any) =>
          y.isChecked == true ? y.amount * y.wholesalePrice : 0
        )
        .reduce((acc: number, curr: number) => {
          return acc + curr;
        }, 0),
    }));

    setCart({
      ...cart,
      shops: shops,
    });
  };

  const mapCartsV2 = (item: any, carts: any) => {
    let shops = carts.shops.map((x: any) => ({
      ...x,
      totalPrice: x.products
        .map((y: any) => y.amount * y.wholesalePrice)
        // .map((y: any) =>  y.amount * (carts?).shops?.shopBuyer) ? y.wholesalePrice : x.products[0].product.price)
        .reduce((acc: number, curr: number) => {
          return acc + curr;
        }, 0),
    }));
    setCart({
      ...cart,
      shops: shops,
    });
  };

  const mapPrice = (carts: any) => {
    let checkCart = carts?.shops?.find((x: any) => x.totalPrice);

    if (checkCart) {
      const newcarts = {
        ...carts,
        totalPrice: carts.shops
          .map((y: any) => y.totalPrice)
          .reduce((acc: number, curr: number) => {
            return acc + curr;
          }, 0),
        totalAmount: carts.shops
          .map((y: any) =>
            y.products
              .map((x: any) => x.amount)
              .reduce((acc: number, curr: number) => {
                return acc + curr;
              }, 0)
          )
          .reduce((acc: number, curr: number) => {
            return acc + curr;
          }, 0),
      };
      setCartPrice(newcarts);
    }
    // else {
    //   carts = {
    //     ...carts,
    //     totalPrice: 0,
    //     totalAmount: 0,
    //   };
    //   setCartPrice(carts);
    // }
  };

  const convertPrice = (value: number) => {
    value = value || 0;
    return value
      .toFixed(2)
      .toString()
      .replace(/\D/g, '')
      .replace(/(\d)(\d{2})$/, '$1.$2')
      .replace(/(?=(\d{3})+(\D))\B/g, ',');
  };

  const delOrderId = async (
    shop: any,
    product: any,
    indexProduct: any
  ) => {
    const isShop = shop;
    const shops = JSON.parse(JSON.stringify(cart.shops));
    const nShop = shops.find((x: any) => x?._id === isShop?._id);
    nShop.products.splice(indexProduct, 1);
    const objShop = shops.find((x: any) => x?._id === shop?._id);
    if (!objShop.products.length) {
      const index = shops.findIndex(
        (x: any) => x?._id === objShop?._id
      );
      shops.splice(index, 1);
    }

    const addCart = shops.map((x: any) => ({
      shop: x?.shop?._id,
      products: x.products.map((y: any) => ({
        amount: y.amount,
        product: y?.product?._id,
      })),
    }));
    const bodyCart = {
      userId: user?._id,
      shops: addCart,
    };

    const orderIds = await axios.patch(
      `/carts/new-cart/${cart?._id}`,
      bodyCart
    );
    if (orderIds) {
      state.shops = [];
      getCarts(user?._id);
    } else {
      return;
    }
  };

  useEffect(() => {
    // mapCarts(state, cart);
    mapCartsV2(state, cart);
  }, [state]);

  useEffect(() => {
    mapPrice(cart);
  }, [cart]);

  //TODO x
  // useEffect(() => {}, [cartPrice]);

  useEffect(() => {
    if (user?._id) {
      getCarts(user?._id);
    }
  }, [user?._id]);

  return (
    <>
      <Layout
        breadcrumbItems={breadcrumbs}
        breadcrumbMarginBottom={50}
      >
        {loading ? (
          <div className={styles.loadingWrapper}>
            <Loading />
          </div>
        ) : (
          <div>
            {shopItems.length > 0 ? (
              <div className={styles.cartWrapper}>
                <>
                  <h1 className={styles.header}>ตะกร้าสินค้า</h1>
                  <div className={styles.cartWrapper}>
                    <div className={styles.cartBoxWrapper}>
                      <div className={styles.cartBox}>
                        {cart.shops.map(
                          (shop: any, indexShop: number) => (
                            <div key={indexShop}>
                              <div
                                className={styles.top}
                                style={{
                                  marginTop: '10px',
                                  paddingBottom: '10px',
                                }}
                              >
                                <div className={styles.check}>
                                  <>
                                    {/* <Checkbox
                                    disabled={
                                      shop?.shop?.shopIsActived &&
                                      !shop.isOutOfStock
                                        ? false
                                        : true
                                    }
                                    checked={shop.isChecked}
                                    onChange={(e) => {
                                      onShopChange(e, shop, indexShop);
                                    }}
                                  ></Checkbox> */}
                                  </>
                                </div>
                                <div className={styles.icon}>
                                  <img
                                    src={`/images/shops/shop-icon-small.svg`}
                                  />
                                </div>
                                <div className={styles.text}>
                                  {shop?.shop?.name}&nbsp;
                                  {shop?.shop?.shopIsActived
                                    ? ''
                                    : '(shop is closed)'}
                                </div>
                              </div>
                              {shop.products.map(
                                (
                                  product: any,
                                  indexProduct: number
                                ) => (
                                  <div
                                    className={styles.mid}
                                    key={indexProduct}
                                    style={{
                                      marginTop: '10px',
                                      paddingBottom: '10px',
                                    }}
                                  >
                                    <div
                                      className={
                                        styles.productWrapper
                                      }
                                    >
                                      <div
                                        className={styles.productItem}
                                      >
                                        <div
                                          className={styles.product}
                                        >
                                          <div
                                            className={styles.check}
                                          >
                                            {/* <Checkbox
                                            disabled={
                                              shop?.shop?.shopIsActived &&
                                              !product?.isOutOfStock
                                                ? false
                                                : true
                                            }
                                            checked={product.isChecked}
                                            onChange={(e) => {
                                              onProductChange(
                                                e,
                                                shop,
                                                product,
                                                indexProduct
                                              );
                                            }}
                                          ></Checkbox> */}
                                          </div>
                                          <div
                                            className={
                                              styles.productCover
                                            }
                                          >
                                            <img
                                              src={
                                                product?.product
                                                  ?.product?.files[0]
                                              }
                                              alt=""
                                              className={styles.img}
                                            />
                                          </div>
                                          <div
                                            className={
                                              styles.productDetailWrapper
                                            }
                                          >
                                            <div
                                              className={
                                                styles.productName
                                              }
                                            >
                                              {
                                                product?.product
                                                  ?.product
                                                  ?.productName
                                              }
                                              &nbsp;
                                              <span
                                                style={{
                                                  color: 'gray',
                                                  fontSize: '10px',
                                                }}
                                              >
                                                (คลังสินค้า:{' '}
                                                {
                                                  product?.product
                                                    ?.stock
                                                }{' '}
                                                )
                                              </span>
                                            </div>

                                            <div
                                              className={
                                                styles.quantity
                                              }
                                            >
                                              {product?.isOutOfStock ? (
                                                <span
                                                  style={{
                                                    color: 'red',
                                                    fontSize: '10px',
                                                    marginTop: '0px',
                                                  }}
                                                >
                                                  จำนวนสินค้าใน stock
                                                  มีไม่เพียงพอ
                                                </span>
                                              ) : (
                                                ''
                                              )}
                                              <Form.Item
                                                label="จำนวน"
                                                rules={[
                                                  { required: true },
                                                ]}
                                              >
                                                &nbsp;
                                                <InputNumber
                                                  value={
                                                    product.amount
                                                  }
                                                  controls={false}
                                                  onChange={(
                                                    value: any
                                                  ) => {
                                                    const reg =
                                                      /^-?\d*(\d*)?$/;
                                                    if (
                                                      (!isNaN(
                                                        value
                                                      ) &&
                                                        reg.test(
                                                          value
                                                        )) ||
                                                      value === '' ||
                                                      value === '-'
                                                    ) {
                                                      onAmountChangeV2(
                                                        value,
                                                        shop,
                                                        product,
                                                        indexProduct
                                                      );
                                                    } else {
                                                      message.warning(
                                                        'กรุณาระบุจำนวนเป็นจำนวนเต็ม'
                                                      );
                                                    }
                                                  }}
                                                  min={1}
                                                  max={
                                                    product?.product
                                                      ?.stock
                                                  }
                                                />
                                                <Tooltip title="">
                                                  &nbsp; ชิ้น
                                                </Tooltip>
                                              </Form.Item>
                                            </div>
                                          </div>
                                        </div>
                                        <div className={styles.price}>
                                          ราคา / ชิ้น ฿{' '}
                                          {convertPrice(
                                            product?.wholesalePrice
                                            // (typeof shop?.shopBuyer === undefined) ? product?.wholesalePrice : product?.product?.price
                                          )}
                                          <div
                                            className={styles.bottoml}
                                          >
                                            <Button
                                              shape="circle"
                                              onClick={() => {
                                                delOrderId(
                                                  shop,
                                                  product,
                                                  indexProduct
                                                );
                                              }}
                                            >
                                              {' '}
                                              ลบ{' '}
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              )}
                              <div className={styles.bottom}>
                                <div
                                  className={styles.left}
                                  style={{ padding: '10px 0px' }}
                                >
                                  <Link
                                    to={`/shops/?id=${shop?.shop?._id}`}
                                  >
                                    เลือกสินค้าอื่นๆต่อ
                                  </Link>
                                </div>
                                <div className={styles.right}>
                                  รวม{' '}
                                  <span
                                    className={[
                                      styles.priceAll,
                                      styles.highlight,
                                    ].join(' ')}
                                  >
                                    ฿
                                    {shop?.totalPrice
                                      ? convertPrice(shop?.totalPrice)
                                      : '0.00'}
                                  </span>
                                </div>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                      {cart.shops.length > 0 ? (
                        <div className={styles.summaryWrapper}>
                          <div className={styles.left}>
                            รวมทั้งหมด{' '}
                            <span className={styles.highlight}>
                              ฿
                              {cartPrice?.totalPrice
                                ? convertPrice(cartPrice?.totalPrice)
                                : '0.00'}
                            </span>
                          </div>
                          <div className={styles.right}>
                            <Button
                              type="primary"
                              onClick={onPaymentClick}
                              loading={loading}
                              disabled={
                                isOutStock ||
                                cartPrice?.totalPrice === 0
                              }
                            >
                              ยืนยันคำสั่งซื้อ
                            </Button>
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                </>
              </div>
            ) : (
              <div className={styles.textAlignCenter}>
                คุณยังไม่มีสินค้าในตะกร้า
                <div className={styles.cartTop}>
                  <Button type="primary" onClick={onClickToShop}>
                    ดูสินค้า
                  </Button>
                </div>
              </div>
            )}
          </div>
        )}
      </Layout>
    </>
  );
};
export default Register;
